import http from "./http";
const baseUrl = "/v1/api/app";

const { post } = http;

const getSolutionPage = (params?: Record<string, unknown>) => post(`${baseUrl}/solution/page`, params);
const getSolutionNoPage = (params: Record<string, unknown>) => post(`${baseUrl}/solution/list`, params);
const createSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/create`, params);
const deleteSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/delete`, params);
const getSolutionDetail = (params: Record<string, unknown>) => post(`${baseUrl}/solution/detail`, params);
const saveSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/save`, params);
const existSolutionPackageName = (params: Record<string, unknown>) =>
  post(`${baseUrl}/solution/packageName/exist`, params);
const existSolutionName = (params: Record<string, unknown>) => post(`${baseUrl}/solution/name/exist`, params);
const existSolutionVersion = (params: Record<string, unknown>) => post(`${baseUrl}/solution/version/exist`, params);
const saveNextSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/next/save`, params);
const auditReleaseSolution = (params: Record<string, unknown>) =>
  post(`${baseUrl}/solution/version/audit/release`, params);
const auditUpgradeSolution = (params: Record<string, unknown>) =>
  post(`${baseUrl}/solution/version/audit/upgrade`, params);
const cancelReleaseSolution = (params: Record<string, unknown>) =>
  post(`${baseUrl}/solution/version/cancel/release`, params);
const cancelUpgradeSolution = (params: Record<string, unknown>) =>
  post(`${baseUrl}/solution/version/cancel/upgrade`, params);
const cancelDownSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/version/cancel/down`, params);
const upgradeVersionSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/version/create`, params);
const auditDownSolution = (params: Record<string, unknown>) => post(`${baseUrl}/solution/version/audit/down`, params);

export default {
  getSolutionPage,
  getSolutionNoPage,
  createSolution,
  deleteSolution,
  getSolutionDetail,
  saveSolution,
  existSolutionName,
  existSolutionPackageName,
  existSolutionVersion,
  saveNextSolution,
  auditReleaseSolution,
  auditUpgradeSolution,
  cancelReleaseSolution,
  cancelUpgradeSolution,
  cancelDownSolution,
  upgradeVersionSolution,
  auditDownSolution,
};
